module.exports = __webpack_public_path__ + "static/img/ic_kzt_2.fab8ee8a.png";